import { render, staticRenderFns } from "./VoidClaim.vue?vue&type=template&id=7ec9240f"
import script from "./VoidClaim.vue?vue&type=script&lang=js"
export * from "./VoidClaim.vue?vue&type=script&lang=js"
import style0 from "./VoidClaim.vue?vue&type=style&index=0&id=7ec9240f&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports